import { HeroSlider } from '@components/hero-slider/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const heroSliderMock: Block<HeroSlider> = {
  type: 'hero-slider',
  data: {
    store: imageMock,
    slider: [imageMock, imageMock],
    isPromoHidden: false,
    virtualTour: {
      preview: imageMock,
      url: 'https://www.google.com/maps/embed?pb=!4v1616066642923!6m8!1m7!1sCAoSLEFGMVFpcE91bW52QVdOc1FBX2xiT2cwcE45WUJDdnZXLWZWVkd4c3hJVzdo!2m2!1d42.646390941508!2d9.4397069480668!3f190.49082538990797!4f-11.473082368577963!5f0.7820865974627469',
    },
  },
};

export const heroSliderAlternativeMock: Block<HeroSlider> = {
  type: 'hero-slider',
  data: {
    store: imageMock,
    slider: [],
    isPromoHidden: true,
    virtualTour: {
      preview: imageMock,
      url: '',
    },
  },
};
